export default "__VITE_ASSET__2YQf5xRC__"